const Empty = {}

export default Empty
